import { call, put, takeLatest } from 'redux-saga/effects';

import { get2ndflList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  yield action.ids.map(function* ({ id, name }) {
    const response = yield call(get2ndflList, action.year, id, name);
    return yield put(
      response.isOk ? requestSuccess(response.data) : requestFailure(response.error),
    );
  });
}

export default function* incomeTypesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
